import { Button, FiRepeat, Flex } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { VALIDATION_STATUSES } from '@bcba/types';
import React, { FC } from 'react';

interface FormApprovalButtonProps {
  status: string;
  disabled?: boolean;
  onClick: () => void;
  isLoading: boolean;
}

export const FormApprovalButton: FC<FormApprovalButtonProps> = (props) => {
  const { status, disabled = false, onClick, isLoading } = props;
  const { t } = useTranslation();
  const showButton = status !== VALIDATION_STATUSES.PENDING_APPROVAL;

  return (
    <Flex alignContent="end" w="full">
      {showButton ? (
        <Button
          marginLeft="auto"
          leftIcon={<FiRepeat />}
          form="form"
          onClick={onClick}
          isDisabled={disabled}
          variant={'primary'}
          isLoading={isLoading}
        >
          {t('signUpRequest.updateData')}
        </Button>
      ) : null}
    </Flex>
  );
};

export default FormApprovalButton;
